import { LegalPage } from './LegalPage';
import Privacy, { frontmatter as fm } from '../../content/privacy.mdx';

export function PrivacyPage() {
  return (
    <LegalPage
      title="Privacy · Brian Ellison Design"
      description="What this site collects and what it doesn't. In plain language."
      canonical="https://brianellisondesign.com/privacy"
      Body={Privacy}
      headline={(fm['headline'] as string) ?? 'Privacy.'}
    />
  );
}
